import type { Observable } from '@acies/observables';

interface IComponentCO2Link {
	readonly co2: string;
	readonly description: string;
	readonly name: string;
	readonly selected: Observable<boolean>;
	readonly self: string;
}

export default class ComponentCO2Link implements IComponentCO2Link {
	public get co2(): string {
		return this.#co2;
	}

	public get description(): string {
		return this.#description;
	}

	public get name(): string {
		return this.#name;
	}

	public get selected(): Observable<boolean> {
		return this.#selected;
	}

	public get self(): string {
		return this.#self;
	}

	#co2: string;
	#description: string;
	#name: string;
	#selected: Observable<boolean>;
	#self: string;
	public constructor({ co2, description, name, selected, self }: IComponentCO2Link) {
		this.#co2 = co2;
		this.#description = description;
		this.#name = name;
		this.#selected = selected;
		this.#self = self;
	}
}
